import React from "react";
import PropTypes from "prop-types";
import InlineError from "../messages/InlineError";
import isEmpty from "lodash/isEmpty";
//import ReCAPTCHA from "react-google-recaptcha";
// Semantic UI Components
import { Form, Button, Message, Icon } from "semantic-ui-react";
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';

class LoginForm extends React.Component {
  state = {
    data: {
      username: "",
      password: "",
    },
    recaptchaValue: "",
    isLoading: false,
    recaptchaReady: false,
    errors: {},
  };

  componentDidMount() {
    console.log("executerecaptcha", this.props)
    this.checkRecaptchaReady();
  }

  checkRecaptchaReady = () => {
    const { executeRecaptcha } = this.props;

    if (executeRecaptcha) {
        this.setState({ recaptchaReady: true });
    } else {
        // espera 100ms y vuelve a intentar
        setTimeout(this.checkRecaptchaReady, 100);
    }
   };


  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  onSubmit = async () => {
    const { executeRecaptcha } = this.props;

    if(!executeRecaptcha){
        this.setState({
            errors: {
                global: "Error cargando el reCAPTCHA. Por favor, recarga la pagina.",
            },
        });
        return;
    }

    try {
        const recaptchaValue = await executeRecaptcha("login");

        const errors = this.validate({
            ...this.state.data,
            recaptchaValue,
        });

        this.setState({errors});

        if(isEmpty(errors)){
            this.setState({ isLoading: true });

            this.props
                .submit({
                    ...this.state.data,
                    recaptchaValue,
                })
                .catch((err) => {
                    if(err.response?.status >= 500) {
                        this.setState({
                            errors:{
                                global: "No se pudo contactar con el servidor",
                            },
                            isLoading: false,
                        });
                    } else {
                        this.setState({
                            errors:err.response.data.errors,
                            isLoading: false
                        });
                    }
                });
        }

    } catch (error) {
        console.error("Error ejecutando reCAPTCHA", error);
        this.setState({
            errors: {
                global: "Error al validar el reCAPTCHA. Intenta nuevamente.",
            },
        });
    }
  }

  validate = (data) => {
    const errors = {};
    if (!data.username) errors.username = "No puede estar en blanco";
    if (!data.password) errors.password = "No puede estar en blanco";
    if (!data.recaptchaValue)
      errors.recaptchaValue = "Error recaptcha V3.";
    return errors;
  };

  render() {
    const { data, errors, isLoading } = this.state;
    return (
      <Form onSubmit={this.onSubmit} loading={isLoading}>
        {errors.global && (
          <Message icon negative>
            <Icon name="lock" />
            <Message.Content>
              <Message.Header>{errors.global}</Message.Header>
              <p>Por favor, intenta nuevamente.</p>
            </Message.Content>
          </Message>
        )}
        <Form.Field error={!!errors.username}>
          <label htmlFor="username">Usuario</label>
          <input
            type="text"
            id="username"
            name="username"
            placeholder="Escriba su usuario"
            value={data.username}
            onChange={this.onChange}
            autoComplete="off"
          />
          {errors.username && <InlineError text={errors.username} />}
        </Form.Field>
        <Form.Field error={!!errors.password}>
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Digite su contraseña"
            value={data.password}
            onChange={this.onChange}
            autoComplete="off"
          />
          {errors.password && <InlineError text={errors.password} />}
        </Form.Field>

        <Form.Field>
            { errors.recaptchaValue && (
              <InlineError text={errors.recaptchaValue} />
            )}
        </Form.Field>

        <Form.Field className="loginButtonFormField">
          <Button
            primary
            content="Ingresar"
            icon="sign in"
            labelPosition="left"
            disabled={!this.state.recaptchaReady || this.state.isLoading}
          />
        </Form.Field>
      </Form>
    );
  }
}

LoginForm.propTypes = {
  submit: PropTypes.func.isRequired,
  executeRecaptcha: PropTypes.func,
};

export default LoginForm
